// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","pgHdr":"App_pgHdr__8PXye","pieChartTitle":"App_pieChartTitle__2CKKB","Numbers":"App_Numbers__HimP0"};